module.exports = __webpack_public_path__ + "static/media/mcb.46a07a24.png";